/**
 * Variant image focus — PhotoSwipe (pswp) zoom
 *
 * The gallery's focus mode (sections/product.liquid) hides non-selected-scent
 * images with CSS. The zoom window is built by <zoom-images> (zoom.js), which
 * collects images with querySelectorAll — ignoring CSS — so without this it
 * would zoom every scent's images.
 *
 * This wraps the element's createZoom() to apply the same rule: keep only images
 * whose slide is tagged with the selected scent (or the shared "All Products"
 * tag), plus filter the pswp thumbnail strip to match. zoom.js itself is a
 * minified vendor asset and is left untouched.
 */
(function () {
  'use strict';

  function handleize(str) {
    return (str || '')
      .toString()
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  var SHARED = handleize('All Products'); // "all-products"

  function selectedScentHandles(section) {
    var handles = {};
    section
      .querySelectorAll('input[data-single-option-selector]:checked')
      .forEach(function (input) {
        // Prefer the Liquid-computed handle (scent picker) to avoid any
        // divergence; fall back to handleizing the raw value.
        var h = input.getAttribute('data-scent-handle') || handleize(input.value);
        if (h) handles[h] = true;
      });
    return handles;
  }

  function patch(ctor) {
    if (!ctor || !ctor.prototype) return;
    var proto = ctor.prototype;
    if (proto._scentFocusPatched) return;

    var original = proto.createZoom;
    if (typeof original !== 'function') return;

    proto._scentFocusPatched = true;

    proto.createZoom = function (index) {
      var section = this.container;
      var focusOn =
        section && section.getAttribute('data-variant-image-focus') === 'true';
      if (!focusOn) return original.call(this, index);

      // Fresh full list every time so the click index stays correct even after
      // a previous focus-filtered open left this.images narrowed.
      var all = Array.prototype.slice.call(
        this.querySelectorAll('[data-zoom-image]')
      );
      var selected = selectedScentHandles(section);

      function inFocus(img) {
        var slide = img.closest('.product__slide');
        var h = slide && slide.getAttribute('data-variant-scent');
        if (!h) return false; // untagged -> hidden in focus mode
        return h === SHARED || selected[h] === true;
      }

      var keepIdx = [];
      all.forEach(function (img, i) {
        if (inFocus(img)) keepIdx.push(i);
      });

      // Misconfigured (no tagged images match) -> fall back to default behaviour
      if (!keepIdx.length) {
        this.images = all;
        return original.call(this, index);
      }

      var visible = keepIdx.map(function (i) {
        return all[i];
      });
      var newIndex = visible.indexOf(all[index]);
      if (newIndex < 0) newIndex = 0;

      // Narrow the images the original reads (also used by its getThumbBoundsFn).
      this.images = visible;

      // Keep the pswp thumbnail strip in sync. The template's children are in the
      // same order as the zoom images, so reuse keepIdx. Restore after the
      // original has read it (it reads innerHTML synchronously).
      var tmpl = section.querySelector('[data-pswp-thumbs-template]');
      var savedTmpl = tmpl ? tmpl.innerHTML : null;
      if (tmpl && tmpl.content) {
        var kids = Array.prototype.slice.call(tmpl.content.children);
        if (kids.length === all.length) {
          tmpl.innerHTML = keepIdx
            .map(function (i) {
              return kids[i].outerHTML;
            })
            .join('');
        }
      }

      try {
        original.call(this, newIndex);
      } finally {
        if (tmpl && savedTmpl !== null) tmpl.innerHTML = savedTmpl;
      }
    };
  }

  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('zoom-images').then(function () {
      patch(customElements.get('zoom-images'));
    });
  }
})();
